module.exports = __webpack_public_path__ + "./Jimmy_21294d15ed0ae46c9b00839b77dc006d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/Jimmy.jpg
// module id = 530
// module chunks = 0